export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/stoichiometry/Activity1_a/spectra.json";